import * as React from "react";
import { connect } from "react-redux";
import {
  IStoreState,
  getFlightMarkersState,
  getGCPRequestState,
} from "../../redux/rootReducer";
import { getFlightMarkerById } from "../../redux/modules/flightMarkers/flightMarkersReducer";
import { getFlightMarkerIcon } from "../../redux/computables/flightMarkerIcon/flightMarkerIcon";
import SidebarItem from "../Generics/SidebarItem";
import { Gray20 } from "@traceair/tds";
import { faintBlue } from "../Generics/_colors";

interface IFlightMarkerItemProps {
  id: string;
  isActive: boolean;
  onClick: () => void;
}
interface IFlightMarkerItemConnectedProps {
  id: string;
  name: string;
  icon: string;
  isActive: boolean;
  onClick: () => void;
}
export default connect(
  (state: IStoreState, { id }: IFlightMarkerItemProps) => ({
    name: getFlightMarkerById(getFlightMarkersState(state), id).name,
    icon: getFlightMarkerIcon(
      getFlightMarkersState(state),
      getGCPRequestState(state),
      id,
    ),
  }),
)(({ name, icon, isActive, onClick }: IFlightMarkerItemConnectedProps) => (
  <SidebarItem
    backgroundColor={isActive ? faintBlue : "#FFFFFF"}
    borderBottomColor={Gray20}
    leftIcon={<img src={icon} />}
    leftLabel={name}
    onLeftIconClick={onClick}
    onLeftLabelClick={onClick}
    onRightLabelClick={onClick}
    onRightIconClick={onClick}
  />
));
